<form
    *transloco="let t; prefix: 'search'"
    class="mx-auto"
    role="search"
    [formGroup]="searchForm"
    (submit)="submit()">
    <div
        class="flex bg-white dark:bg-dark-background py-0.5 group"
        [ngClass]="{
            'rounded-md': location === 'search-box' || location === 'search-results',
            'focus-within:py-2 transition-all': location === 'header',
            'rounded-xl focus-within:shadow-search-bar': location === 'side-nav' || location === 'header',
            'py-2': (hasShadow && autocompleteInput?.autocomplete?.panelOpen && location === 'header') || location === 'side-nav',
            'rounded-b-none': autocompleteInput?.autocomplete?.panelOpen,
        }">
        <label
            for="searchForm"
            class="sr-only">
            {{ t('placeholder') }}
        </label>
        <big-ui-autocomplete-input
            *transloco
            [id]="'searchForm'"
            [isRequired]="false"
            name="searchForm"
            class="flex-1"
            formControlName="term"
            [inputStyle]="inputStyle"
            [autocompleteStyle]="autocompleteStyle"
            [buttonStyle]="
                'flex w-7 group-focus-within:h-7 justify-center items-center fill-primary dark:fill-white absolute right-1 flex items-center justify-center hover:fill-primary-light'
            "
            (optionSelected)="onOptionSelected()"
            [optionsValueTransformer]="transformOptionValue"
            [placeholder]="placeholder ? placeholder : t('placeholder')"
            [options]="suggestions$ | async">
            <button
                class="flex items-center ml-2 mr-3 w-7 group-focus-within:h-7 fill-primary hover:fill-primary-light dark:fill-white dark:hover:fill-gray-400"
                type="submit"
                [attr.aria-label]="t('search')">
                <big-icon
                    [icon]="iconSearch"
                    [size]="'w-5'"
                    class="m-0.5" />
            </button>
        </big-ui-autocomplete-input>
    </div>
</form>
